<template>
  <div class="container">
    <div class="home">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">用户管理</div>
          </div>
          <div class="addOrg flexrcc">
            <div class="btn" @click="showModal">充值</div>
          </div>
        </div>
      </div>
      <div class="table">
        <Table max-height="" :loading="loading" border stripe :columns="tableHead" :data="tableData"></Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total></Page>
          </div>
        </div>
      </div>
    </div>
    <Modal :closable="false" v-model="RechargeModal" title="充值" width="350">
      <div class="applyModal">
        <div class="title-box">
          <span>*</span>
          <div class="title">充值金额</div>
        </div>
        <input type="text" v-model="money" class="name-input" />
        <span>元</span>
      </div>
      <div slot="footer">
        <div style="display: flex;justify-content: center;">
          <Button style="width: 138px;" @click="cancelModal">取消</Button>
          <Button style="width: 138px;background-image: linear-gradient(180deg, #478EE9 0%, #2255CE 100%);color: white;" :loading="modalLoading" @click="handleApply">确认</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "customer",
  data () {
    return {
      loading: false,
      tableHead: [
        // 单选
        {
          width: 60,
          align: "center",
          key: 'checkBox',
          _isChecked: false,
          resizable: true,
          render: (h, params) => {
            return h('div', [
              h('Checkbox', {
                props: {
                  value: params.row.checkBox
                },
                on: {
                  'on-change': (e) => {
                    this.tableData.forEach((items) => {
                      this.$set(items, 'checkBox', false);
                    });
                    this.tableData[params.index].checkBox = e;
                    this.tableSelection = this.tableData[params.index];
                  }
                }
              })
            ])
          }
        },
        {
          title: "用户名称",
          key: "realName",
          resizable: true,
        },
        {
          title: "手机号",
          key: "buyerPhone",
          resizable: true,
        },
        {
          title: "累计充值(元)",
          key: "sumMoney",
          resizable: true,
        },
        {
          title: "累计消费(元)",
          key: "subMoney",
          resizable: true,
        },
        {
          title: "当前余额(元)",
          key: "balanceMoney",
          resizable: true,
        }
      ],
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 8,
      tableSelection: [],
      RechargeModal: false,
      modalLoading: false,
      money: null
    }
  },
  created () {
    this.getTableData();
  },
  methods: {
    getTableData () {
      this.loading = true;
      const session = JSON.parse(localStorage["session"]);
      this.$http.post({
        sessionId: session.sessionId,
        modeCode: "yWKoOCmZqbHcjZt2HVrtlnZBpsgxFr7c",
        pageIndex: this.page,
        pageSize: this.pageSize
      }).then((res) => {
        this.loading = false;
        this.total = res.count;
        this.tableData = res.result_ctn;
      });
    },
    changePage (page) {
      this.page = page;
      this.getTableData();
    },
    cancelModal () {
      this.RechargeModal = false;
      this.money = null;
    },
    handleApply () {
      if (!this.money) {
        this.$Message["error"]({
          background: true,
          content: "请输入充值金额!"
        });
        return;
      }
      const reg = /^\+?[1-9]\d*$/;
      const moneyReg = reg.test(this.money);
      if (moneyReg) {
        const session = JSON.parse(localStorage["session"]);
        this.modalLoading = true;
        let data = {
          modeCode: "ly8vmiCpPVtclcNz358e1nU5tRbipbiQ",
          userId: session.userId,
          sessionId: session.sessionId,
          toUserId: this.tableSelection.userId,
          money: this.money
        }
        this.$http.post(data).then(res => {
          this.modalLoading = false;
          if (res.code == 1) {
            this.cancelModal();
            this.$Message["success"]({
              background: true,
              content: "操作成功！",
            });
            this.getTableData();
          } else {
            this.$Message["error"]({
              background: true,
              duration: 3,
              content: res.msg
            });
          }
        })
      } else {
        this.$Message["error"]({
          background: true,
          content: "请输入正确的金额!"
        });
      }
    },
    showModal () {
      if (this.tableSelection.length === 0) {
        this.$Message["error"]({
          background: true,
          content: "请先选择表格项！",
        });
        return;
      } else {
        this.RechargeModal = true;
      }
    }
  },
}
</script>

<style scoped lang="less">
.container {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #fff;

  .home {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }
    }

    .table {
      width: 928px;
      margin: 18px 0 0 26px;

      /deep/.ivu-table-cell {
        padding-left: 12px;
        overflow: unset;
      }

      .icon-box {
        & > div {
          position: relative;

          &:hover {
            color: #4a90e2 !important;
          }

          &:last-child {
            &:hover {
              color: #d0021b !important;
            }
          }
        }
      }
    }
  }

  /deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);

    .ivu-modal {
      top: 0;
    }
  }

  /deep/ .ivu-btn-primary {
    background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
    margin: 0 10px;
  }

  /deep/ .ivu-modal-header {
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    height: 48px;
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/ .ivu-table th {
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/ .ivu-table th:first-child {
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/ .ivu-table th:last-child {
    border-top-right-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: left;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-inner:after {
    background-color: #2c59c3;
  }

  /deep/.ivu-radio-checked .ivu-radio-inner {
    border-color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }

  input:disabled {
    background: #f5f7fa;
    border: 1px solid rgba(118, 118, 118, 0.3);
    box-shadow: none;
  }

  /deep/.ivu-input[disabled] {
    color: #000;
  }

  /deep/.ivu-form-item {
    margin-bottom: 0;
  }
}

.applyModal {
  display: flex;
  align-items: center;
  span:first-child {
    margin-right: 10px;
  }
  .name-input {
    margin: 0 5px;
    height: 48px;
    border-radius: 8px;
    padding-left: 24px;
  }

  .title-box {
    margin: 14px 0 8px 0;
    display: flex;
    span {
      color: #d0021b;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #9097a9;
      letter-spacing: 0.3px;
      line-height: 22px;
    }
  }
}
</style>